// extracted by mini-css-extract-plugin
export var avatarContainer = "_g5-0";
export var avatarTypingWave = "_g5-i";
export var gray = "_g5-f";
export var green = "_g5-c";
export var icon = "_g5-9";
export var image = "_g5-1";
export var lg = "_g5-6";
export var md = "_g5-5";
export var presenceDot = "_g5-b";
export var red = "_g5-d";
export var sm = "_g5-4";
export var status = "_g5-a";
export var typingDot = "_g5-h";
export var typingPill = "_g5-g";
export var xl = "_g5-7";
export var xs = "_g5-3";
export var xxl = "_g5-8";
export var xxs = "_g5-2";
export var yellow = "_g5-e";